export const SUPPORTS_LIST_FORMAT = "ListFormat" in Intl;
